export default __webpack_public_path__ + "static/media/Top.951d3bc7.svg";